
import apiClient from '../helpers/apiClient';
import { authHeader } from '../helpers/authHeader';


export const packageService = {
    getPackageList, packageMasterData, subOrUpdatePackage, packageDetails,
    deletePackage, deliveredPackage, packageSearch
  
    
};





async function  subOrUpdatePackage(form) {
    return  apiClient.post(`/inventory/new-or-update-package`,form, authHeader());
}


async function  getPackageList() {
    return  apiClient.get(`/inventory/packages`, authHeader());
}


async function  deliveredPackage(form) {
    return  apiClient.put(`/inventory/delivered-shipping`, form, authHeader());
}


async function  packageMasterData() {
    return  apiClient.get(`/inventory/packages-master-data`, authHeader());
}


async function  packageSearch(searchText) {
    return  apiClient.get(`/inventory/packages-search?search=${searchText}`, authHeader());

}


async function  packageDetails(id) {
    return  apiClient.get(`/inventory/package-details/${id}`, authHeader());
}


async function  deletePackage(id) {
    return  apiClient.delete(`/inventory/delete-package/${id}`, authHeader());
}











